import { Box, Stack } from "@mui/material";
import { VisibleElement } from "../lib/hooks/VisibleElement";
import React, { useRef, useState } from "react";
import ReactPlayer from "react-player/lib";
import PropTypes from "prop-types";

const VideoContainerHome = ({
   videoUrl,
   direction = "row",
   title,
   subTitle,
   subComponent,
   alternComponent,
   videoPlayerProps,
}) => {
   const videoIsVisible = useRef(null);
   const [isPlaying, setIsPlaying] = useState(false);
   const portview = videoIsVisible !== null ? VisibleElement(videoIsVisible, `-280px`) : false;
   return (
      <Stack direction={"column"} spacing={2} pt={8} sx={{maxWidth:'1300px'}}>
         
         <Stack
            direction={{ xs: direction === "row" ? "column" : "column-reverse", md: direction }}
            spacing={{ xs: 5, sm: 5, md: 2, lg: 5 }}
            
         >
            <Stack direction={"column"} alignItems={"center"}  flex={1}>
               
               <Box mt={-1} ref={videoIsVisible} {...videoPlayerProps} sx={{ minHeight:'330px'}}>
                  <ReactPlayer
                     style={{ position: "absolute", top: 0, right: 0, width: "100%", height: "100%", maxHeight:'430px' }}
                     playing={isPlaying && portview}
                     muted
                     playsinline
                     loop
                     onReady={() => setIsPlaying(true)}
                     url={videoUrl}
                     height={"100%"}
                     width={"100%"}
                  />
                  
               </Box>
               <Box py={0} width={"90%"} minHeight={"40px"}>
                  {subComponent}
               </Box>
            </Stack>
            <Box flex={1}>{alternComponent}</Box>
         </Stack>
      </Stack>
   );
};

VideoContainerHome.propTypes = {
   videoUrl: PropTypes.string.isRequired,
   direction: PropTypes.string.isRequired,
   title: React.Component,
   subTitle: React.Component || PropTypes.string,
   subComponent: React.Component,
   alternComponent: React.Component,
   videoPlayerProps: PropTypes.object,
};

export default VideoContainerHome;
